<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/admin/trilha'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para listagem de cursos"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Aqui é possível cadastrar um novo curso de capacitação. Após o
              cadastro inicial, é possível adicionar materiais e atualizar as
              informações do curso a ser disponibilizado às startups.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    <i class="fas fa-graduation-cap mr-2"></i> Novo curso
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <form role="form">
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <base-input
                      label="Título do curso*"
                      v-model.trim="model.curso.title"
                      placeholder="Digite o título"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label d-block"
                      >Está ativo?
                      <i
                        class="fas fa-info-circle ml-1"
                        v-tooltip="
                          'Um curso <b>ativo</b> fica visível para as startups que possuem acesso, enquanto um curso <b>inativo</b> fica oculto para todas startups.'
                        "
                      ></i
                    ></label>
                    <base-input>
                      <base-switch
                        v-bind:value="model.curso.is_active"
                        @input="switchChangedHandler($event, 'is_active')"
                      />
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Subtítulo do curso (opcional)"
                      v-model.trim="model.curso.subtitle"
                      placeholder="Digite o subtítulo"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Apresentador (opcional)"
                      v-model.trim="model.curso.presenter"
                      placeholder="Digite o nome do apresentador"
                    />
                  </div>
                  <div class="col-lg-12">
                    <base-input label="Descrição do curso (opcional)">
                      <textarea
                        rows="2"
                        v-model="model.curso.description"
                        class="form-control"
                        placeholder="Escreva aqui..."
                      >
                      </textarea>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input label="Objetivos do curso (opcional)">
                      <textarea
                        rows="2"
                        v-model="model.curso.goals"
                        class="form-control"
                        placeholder="Escreva aqui..."
                      >
                      </textarea>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input label="Requisitos do curso (opcional)">
                      <textarea
                        rows="2"
                        v-model="model.curso.requirements"
                        class="form-control"
                        placeholder="Escreva aqui..."
                      >
                      </textarea>
                    </base-input>
                  </div>
                </div>
                <div class="row ml-lg-2" v-if="error">
                  <div class="col-lg-12 text-center">
                    <base-alert type="danger">{{ error }}</base-alert>
                  </div>
                </div>
                <div class="text-right">
                  <base-button
                    type="primary"
                    class="mt-3"
                    :custom="true"
                    @click="handleOpenModalConfirmation"
                    :disabled="!isValidModel"
                    >Cadastrar novo curso</base-button
                  >
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation">
        <div class="py-3 text-center">
          <i class="fas fa-graduation-cap fa-3x"></i>
          <h4 class="heading mt-4">Confirmar criação</h4>
          <p class="mt-3 mb-0">
            Você confirma a criação do curso
            <span class="font-weight-bold">{{ model.curso.title }}</span
            >?
          </p>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button type="white text-success" @click="handleSubmitNewCourse">
          Confirmar criação
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "curso-form",
  data() {
    return {
      model: {
        curso: {
          title: "",
          is_active: true,
          subtitle: "",
          presenter: "",
          description: "",
          goals: "",
          requirements: "",
        },
      },
      requiredFields: ["title"],
      modals: {
        modalConfirmation: false,
      },
      error: "",
    };
  },
  methods: {
    handleOpenModalConfirmation() {
      this.modals.modalConfirmation = true;
    },
    async handleSubmitNewCourse(e) {
      e.preventDefault();
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation,
        width: 90,
        height: 90,
        opacity: 0,
        color: "white",
      });
      this.error = "";
      try {
        const courseData = this.model.curso;
        const { data } = await api.post("/admin/courses", courseData);
        this.$toasted.show("Novo curso cadastradro com sucesso");
        this.$router.push(`/admin/trilha/cursos/${data.id}/editar`);
      } catch (e) {
        const genericError = "Ocorreu um erro ao cadastrar o curso.";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.error = hasErrorResponseData ? customError : genericError;
        this.$toasted.error(genericError);
        this.modals.modalConfirmation = false;
      }
      loader.hide();
    },
    switchChangedHandler(event, obj) {
      if (typeof event === "boolean") this.model.curso[obj] = event;
    },
  },
  computed: {
    isValidModel() {
      const curso = this.model.curso;
      for (const key of this.requiredFields) {
        if (curso[key] === "") return false;
      }
      return true;
    },
  },
};
</script>
